<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stockin">{{$t('stock_in_list')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="saveClick"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.stockin.BranchId.required">- សូមធ្វើកាបញ្ចូលសាខា</div>
                        <div class="error" v-if="!$v.stockin.EmployeeId.required">- សូមធ្វើកាបញ្ចូលឈ្មោះ</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.stockin.BranchId.$error }">
                                <label class="label-control blue">{{$t('branch_name')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.stockin.BranchId.$model">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.stockin.EmployeeId.$error }">
                                <label class="label-control blue">{{$t('receiver')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.stockin.EmployeeId.$model">
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('invoice_no')}}</label>
                                <div>
                                     <input type="text" class="form-control form-control-sm" v-model="stockin.DocSourceNo" readonly/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="stockdate"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm table-grid no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center blue" style="width: 50px;">{{$t('no')}}</th>
                                        <th class="blue">{{$t('item_name')}}</th>
                                        <th class="blue">{{$t('description')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('uom')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('qty')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('qty_in')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td style="width: 330px">{{ret.ItemName}}</td>
                                        <td class="cell-input"><input type="text" class="form-control form-control-sm" v-model="ret.Description" /></td>
                                        <td>{{ret.UomName}}</td>
                                        <td>{{ret.Quantity}}</td>
                                        <td class="cell-input"><input type="number" class="form-control form-control-sm" v-model="ret.QuantityIn" min="0" @blur="limitNumber(ret)"/></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
export default {
    data(){
        return {
            title: this.$t('stock_in_create'),
            branchs: [],
            stockin: {
                BranchId: '',
                EmployeeId: '',
                DocSource: 'Invoice',
                DocSourceNo: ''
            },
            lines: [],
            employees: [],
            stockdate: this.$now().format('YYYY-MM-DD'),
            action: 'stockin/save',
        }
    },
    created(){
        this.getBranch();
        this.getEmployee();
        this.getInvoiceNo(this.$route.params.id);
    },
    validations:{
        stockin: {
            BranchId: { required },
            EmployeeId: { required }
        }
    },
    methods: {
        getBranch(){
            this.$api().post('branch/list', { Limit: 0 }).then(res => {
                if(this.$isValid(res)){
                    this.branchs = res.data.Data;
                }
            });
        },
        saveClick(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                let loading = this.$loading.show();
                this.stockin.InDateAt = this.stockdate;
                let req = {
                    StockIn: this.stockin,
                    StockInLines: this.lines
                };
                this.$api().post(this.action, req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/stockin');
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        getEmployee: function(){
            this.$api().post('employees', { Limit: 0 }).then(res => {
                if(this.$isValid(res)){
                    this.employees = res.data.Data;
                }
            });
        },
        limitNumber: function(item) {
            if(isNaN(item.QuantityIn) || item.QuantityIn < 0) item.QuantityIn = item.OldQuantity;
            else item.OldQuantity = item.QuantityIn;
        },
        getInvoiceNo(id) {
            let self = this;
            let loading = this.$loading.show();
            self.$api().post('po/invoice/find/stockin', { Id: id }).then(res => {
                if (this.$isValid(res)) {
                    this.stockin.DocSourceNo = res.data.Json.Header.Num;
                    this.lines = res.data.Json.Lines;
                }
            }).finally(function() { loading.hide(); });
        }
    }
}
</script>